import { render, staticRenderFns } from "./CheckboxColor.vue?vue&type=template&id=44854624&scoped=true&"
import script from "./CheckboxColor.vue?vue&type=script&lang=js&"
export * from "./CheckboxColor.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxColor.vue?vue&type=style&index=0&id=44854624&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44854624",
  null
  
)

export default component.exports